import { useState, useEffect } from 'react';
import { decodeStorage, encodeStorage } from 'newFunctions/storageBase64'
import { getClientT1, postClientT1 } from 'services/T1Pagos'
import { BASE_PATH_API, BASE_PATH_API_DEV, STAGE_DIRNAME, TIMEOUT_TIME } from 'constants/general';
import { formatResponse } from 'newFunctions/formatResponse';

export function useValUserT1(){

    const [responseGetT1, setResponseGetT1] =useState()
    const [postT1, setPostT1] = useState()
    const clientT1 = decodeStorage('clientT1')
    const profileData = decodeStorage('profileData')

    const [tokenT1Card, setTokenT1Card] = useState(clientT1.id)



    const getClientT1 = async () => {
        try{
            const profileData = decodeStorage('profileData')
            let token = decodeStorage('access_token')
            let apiURL = null
        
            if(STAGE_DIRNAME === "dev"){
                apiURL = `${BASE_PATH_API_DEV?.userProfile}/t1pagos/v2/clients/${profileData?.idClaro}`
            }else{
                apiURL = `${BASE_PATH_API}/t1pagos/v2/clients/${profileData?.idClaro}`
            }
        
            const config = {
                method: 'get',
                url: apiURL,
                timeout: TIMEOUT_TIME,
                withCredentials: false,
                crossdomain: true,
                headers: {
                    'Content-Type': 'application/json; charset=utf-8',
                    'Authorization': `Bearer ${token}`
                }
            };
            const response = await fetch(apiURL, config);
            const data = await formatResponse(response)
            setResponseGetT1( data );

        }catch (error) {
            console.error('Error useValUserT1:', error);
            throw error;
        }
    }



    useEffect(()=>{
        if(profileData){
            if(clientT1 || !clientT1){
                if( (!clientT1?.external_id) || (profileData?.idClaro != clientT1?.external_id)){
                    getClientT1()
                }
            }
        }
    },[])

    useEffect(()=>{
        if(responseGetT1){
            if(responseGetT1?.statusCode === 200){
                if(responseGetT1?.data){
                    if(responseGetT1?.data?.data){    
                        let cT1 = {
                            id: responseGetT1?.data?.data?.id,
                            external_id: responseGetT1?.data?.data?.id_externo
                        }
                        encodeStorage('clientT1', cT1)
                        setTokenT1Card(responseGetT1.data.data.id)
                    }
                }
            }
            if(responseGetT1.statusCode === 404){
                postClientT1()
                .then(setPostT1)
            }
        }
    },[responseGetT1])

    useEffect(()=>{
        if(postT1){
            if(postT1.statusCode === 201){
                if(postT1.data){
                    if(postT1.data.data){  
                        let cT1 = {
                            id: postT1.data.data.id,
                            external_id: postT1.data.data.id_externo
                        }
                        encodeStorage('clientT1', cT1)
                        setTokenT1Card(postT1.data.data.id)
                    }
                }
            }
            if(responseGetT1.statusCode === 404){
                
            }
        }
    },[postT1])

    return{
        tokenT1Card
    }
}
